import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pepAttachmentEllipsis',
})
export class PepAttachmentEllipsis implements PipeTransform {

  transform(value: any, length: number): any {
    if (!value || typeof length === 'undefined') {
      return value;
    }

    const splitValue = value.split('.');
    let ext = '';

    if (splitValue.length > 1) {
      ext = splitValue.pop();
    }

    if (value.length > length) {
      return value.substring(0, length - ext.length) + '...' + ext;
    } else {
      return value;
    }
  }
}
